import { cn } from './cn';

const sizeMap = {
  sm: 'w-4 h-4 border-2',
  md: 'w-6 h-6 border-2',
  lg: 'w-8 h-8 border-[3px]',
} as const;

type SpinnerSize = keyof typeof sizeMap;

interface SpinnerProps {
  size?: SpinnerSize;
  className?: string;
  'aria-label'?: string;
}

export function Spinner({ size = 'md', className, 'aria-label': ariaLabel = 'Loading' }: SpinnerProps) {
  return (
    <div
      role="status"
      aria-label={ariaLabel}
      className={cn(
        'rounded-full animate-spin opacity-60',
        'border-current border-t-transparent',
        sizeMap[size],
        className,
      )}
    />
  );
}
